import React from 'react';
import styled from 'styled-components';

const ReviewLeftComponent = () => (
  <ReviewRightComponentWrapDiv>
    <ReviewRightComponentInnerWrapDiv>
      <GuestLikeHeaderWrapDiv>
        <GuestLikeLoaderSpan></GuestLikeLoaderSpan>
      </GuestLikeHeaderWrapDiv>

      <AminitiesTypeOuterWrapDiv>
        <AminitiesKindWrapSpan></AminitiesKindWrapSpan>
        <AminitiesKindWrapOneSpan></AminitiesKindWrapOneSpan>
        <AminitiesKindWrapTwoSpan></AminitiesKindWrapTwoSpan>
        <AminitiesKindWrapThreeSpan></AminitiesKindWrapThreeSpan>
        <AminitiesKindWrapFourSpan></AminitiesKindWrapFourSpan>
        <AminitiesKindWrapFiveSpan></AminitiesKindWrapFiveSpan>
      </AminitiesTypeOuterWrapDiv>
    </ReviewRightComponentInnerWrapDiv>
  </ReviewRightComponentWrapDiv>
);

export default ReviewLeftComponent;

const ReviewRightComponentWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding:${props.theme.spacing.large};
  width:50%;

`,
);

const ReviewRightComponentInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;

  width:100%;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  border-radius:${props.theme.misc.borderRadius.large};

`,
);

const GuestLikeHeaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  padding:${props.theme.spacing.large};

`,
);

const GuestLikeLoaderSpan = styled.span(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin-right:${props.theme.spacing.large};
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:17rem;
  height:2.8rem;

`,
);

const AminitiesTypeOuterWrapDiv = styled.div(
  props => `
  display: flex;
  flex-direction: row;
  flex-wrap:wrap;
  padding:${props.theme.spacing.large};

`,
);

const AminitiesKindWrapSpan = styled.div(
  props => `
display:flex;
flex-wrap: wrap;
flex-direction: row;
margin-right:${props.theme.spacing.large};
margin-bottom:${props.theme.spacing.large};
background-color:${props.theme.colors.goBrandBlue.medium};
border-radius:${props.theme.misc.borderRadius.base};
width:18.8rem;
height:3rem;

`,
);

const AminitiesKindWrapOneSpan = styled.div(
  props => `
display:flex;
flex-wrap: wrap;
flex-direction: row;
margin-right:${props.theme.spacing.large};
margin-bottom:${props.theme.spacing.large};
background-color:${props.theme.colors.goBrandBlue.medium};
border-radius:${props.theme.misc.borderRadius.base};
width:15rem;
height:3rem;

`,
);

const AminitiesKindWrapTwoSpan = styled.div(
  props => `
display:flex;
flex-wrap: wrap;
flex-direction: row;
margin-right:${props.theme.spacing.large};
margin-bottom:${props.theme.spacing.large};
background-color:${props.theme.colors.goBrandBlue.medium};
border-radius:${props.theme.misc.borderRadius.base};
width:12.1rem;
height:3rem;

`,
);

const AminitiesKindWrapThreeSpan = styled.div(
  props => `
display:flex;
flex-wrap: wrap;
flex-direction: row;
margin-right:${props.theme.spacing.large};
background-color:${props.theme.colors.goBrandBlue.medium};
border-radius:${props.theme.misc.borderRadius.base};
width:16.5rem;
height:3rem;

`,
);

const AminitiesKindWrapFourSpan = styled.div(
  props => `
display:flex;
flex-wrap: wrap;
flex-direction: row;
margin-right:${props.theme.spacing.large};
background-color:${props.theme.colors.goBrandBlue.medium};
border-radius:${props.theme.misc.borderRadius.base};
width:8.5rem;
height:3rem;

`,
);

const AminitiesKindWrapFiveSpan = styled.div(
  props => `
display:flex;
flex-wrap: wrap;
flex-direction: row;
margin-right:${props.theme.spacing.large};
background-color:${props.theme.colors.goBrandBlue.medium};
border-radius:${props.theme.misc.borderRadius.base};
width:12rem;
height:3rem;

`,
);
